/* eslint-disable */
export default {
  topic: 'Titolo della riunione',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
